import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@surfline/quiver-react';
import config from '../../config';


class RedeemForm extends Component {
  constructor(props) {
    super(props);
    this.state = { code: '' };
  }

  handleChange = (event) => {
    this.setState({ code: event.target.value });
  };

  handleSubmit = async (event) => {
    const { submitHandler } = this.props;
    event.preventDefault();
    await submitHandler(this.state.code);
  }

  render() {
    const {
      submitting,
    } = this.props;
    const { code } = this.state;
    return (
      <div>
        <form className="redeem-form" onSubmit={this.handleSubmit}>
          <input
            required
            type="text"
            name="code"
            value={code}
            onChange={this.handleChange}
            placeholder="Code"
          />
          <Button loading={submitting}>
            Redeem
          </Button>
        </form>
        <a href={config.giftRedeemHelpUrl} className="gift-card-learn-more">Need help redeeming your gift?</a>
      </div>
    );
  }
}

RedeemForm.propTypes = {
  submitHandler: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

RedeemForm.defaultProps = {
  submitting: false,
};

export default RedeemForm;
